module.exports = __webpack_public_path__ + "assets/img/timg.1661c20d.gif";